module.exports = __webpack_public_path__ + "static/media/ROLLOVER_STATEMENT.cbcfcfcf.svg";